import { post } from '@/utils/request'
import { getRoles } from '@/utils/auth'

// 接口前缀
function apiFirstName() {
  return getRoles()[0] || 'taoke'
}

/**
 * 淘宝客修改个人信息 
 *
 * @param {String} sex            性别: 0保密 1男 2女
 * @param {String} birthday       生日 YYYY-MM-DD
 * @param {String} province       省: '广东省'
 * @param {String} city           市: '广州市'
 * @param {Number} qq             qq: ''
 * @param {String} job            工作类型: [公司 工作室/团队/其他组织 自由职业]
 * @param {String} company        单位名称: ''
 * @param {String} job_title      部门或职位: ''
 * @param {String} work_type      工作性质: 兼职 全职
 * @param {String} sale_type      推广方式: 'QQ群,微信,微博,网站,APP,线下推广'
 * @param {String} income_type    推广收益
 */
export function myinfo_edit(data) {
  return post(`${apiFirstName()}_myinfo_edit`, data)
}

/**
 * 淘宝客修改自己手机号 
 *
 * @param {String} telephone      手机号码（新的）	
 * @param {String} telephone_code 手机号验证码 auth_sms_code	
 */
export function taoke_mytelephone_change(data) {
  return post('taoke_mytelephone_change', data)
}

/**
 * 淘宝客修改自己email 
 *
 * @param {String} email              email（新的）		
 * @param {String} telephone_code 手机号验证码 auth_sms_code
 * 	
 */
export function taoke_myemail_change(data) {
  return post('taoke_myemail_change', data)
}

/**
 * 淘宝客修改自己密码 
 *
 * @param {String} password  旧密码		
 * @param {String} password1 新密码
 * @param {String} password2 再次输入新密码
 */
export function taoke_mypassword_change(data) {
  return post('taoke_mypassword_change', data)
}

/**
 * 淘客查看余额变化记录  
 *
 * @param {String} page             页码
 * @param {String} pagesize         页码大小
 * 	
 */
export function taoke_money_log(data) {
  return post('taoke_money_log', data)
}

/**
 * 地区列表 
 *
 * @param {String} atype	          地区类型 1省 2直辖市 3地级市 4县级市 5城市区划
 * @param {String} parent_id	      上级地区id 最高级别是0（默认是0）    
 */
export function area(data) {
  return post('area', data)
}


/**
 * 充值
 * @param {String} money	          充值金额
 * @param {String} return_url	      跳回地址
 */
export function taoke_charge(money, return_url) {
  return post('taoke_charge', { money, return_url })
}

/**
 * 充值记录查询
 * @param {String} orderno 充值订单号
 */
export function taoke_charge_query(orderno) {
  return post('taoke_charge_query', { orderno })
}